module.exports = {
    title: "Opportunity Resource List",
    crud: {
        create: "Create Opportunity Resource",
        edit: "Edit Opportunity Resource",
        view: "View Opportunity Resource",
        view_media: "Opportunity Resource Media",
    },
    table: {
        title: "Title",
        description: "Description",
        noOfResource: "No Of Resource",
        minBudget: "Min Budget",
        maxBudget: "Max Budget",
    },
    form: {
        title: "Title",
        description: "Description",
        noOfResource: "No Of Resource",
        minBudget: "Min Budget",
        maxBudget: "Max Budget",
        currency: "Currency",
        user: "User",
        company: "Company",
        experience: "Experience",
    },
}